import React, { useState, useEffect  } from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { isEmpty, map, size } from "lodash"
import { Card, CardBody, Col, Container, Row, Table, CardImg,CardTitle,CardText } from "reactstrap"
import * as moment from "moment"
import { ToWords } from 'to-words'
import { getStoreSettings as onGetStoreSettings } from "store/products/actions"
import { useSelector, useDispatch } from "react-redux";

const toWords = new ToWords({
  localeCode: 'en-IN',
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
  }
});

//const InvoiceDetailV2 = props => {
const InvoiceDetailV5 = React.forwardRef((props, ref) => {
  const [salesDetails, setSalesDetails] = useState()
  const [storeDetails, setStoreDetails] = useState()
  const [customerDetails, setCustomerDetails] = useState()
  const [defaultFootNote, setDefaultFootNote] = useState('')
  const [settings, setSettings] = useState()

  /*
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(onGetStoreSettings())
  }, []);

  const { settings} = useSelector(state => ({
    settings: state.Products.settings
  }))
  */
 
  useEffect(() => {
    if(settings && settings.length > 0){
      const defaultFootNote = settings.filter(each => each.settingid == 'DEFAULT_RECEIPT_FOOTNOTE')
      if(defaultFootNote && defaultFootNote.length > 0){
        const defaultFootNoteValue = defaultFootNote[0].settingvalue
        setDefaultFootNote(defaultFootNoteValue)
      }
    }
  }, [settings]);

  useEffect(() => {
    //if(props && props.fromSales){
      //console.log('>0:'+JSON.stringify(props.salesDetails))
      //console.log('>1:'+JSON.stringify(props.storeDetails))
      //console.log('>2:'+JSON.stringify(props.customerDetails))
      //console.log('>3:'+JSON.stringify(props.settings))
      setSalesDetails(props.salesDetails)
      setStoreDetails(props.storeDetails)
      setCustomerDetails(props.customerDetails)
      setSettings(props.settings)
    //}
  }, [props])

  function isNonZeroNumber(num){
    if(Number(num) && Number(num) != 0){
      return true;
    }
    else{
      return false;
    }
  }

  return (
    <React.Fragment>
      <div className="half-print-page-a4 pt-2" id="invoice-detail-toprint" ref={ref}>
        <Container fluid>
        {!isEmpty(salesDetails) && !isEmpty(storeDetails) && (
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Table className="table-sm mb-0 pb-0 font-size-12">
                    <tbody>
                      <tr>
                        <td className="pb-0">
                          <div className="font-size-13"><strong>{storeDetails.storename}</strong></div>
                          {storeDetails && storeDetails.storeaddress && storeDetails.storeaddress != '' && 
                            <div>{storeDetails.storeaddress}</div>
                          }
                          { (storeDetails && storeDetails.storecity && storeDetails.storecity != '') ? storeDetails.storecity + " - " : "" }
                          { (storeDetails && storeDetails.storepostalcode && storeDetails.storepostalcode != '') ? storeDetails.storepostalcode : "" }
                          { (storeDetails && storeDetails.storestate && storeDetails.storestate != '') ? ", "+storeDetails.storestate : "" }
                          { (storeDetails && storeDetails.storecountry && storeDetails.storecountry != '') ? ", "+storeDetails.storecountry : "" }

                          {storeDetails && storeDetails.storemobile && storeDetails.storemobile != '' && 
                            <div>{"Mob: "}{storeDetails.storemobile}{", Phone: "}{storeDetails.storephone}
                            </div>
                          }
                          {storeDetails && storeDetails.storeemail && storeDetails.storeemail != '' && <div>
                              {"Email: "}{storeDetails.storeemail}
                          </div>}
                          {storeDetails && storeDetails.storegstin && storeDetails.storegstin != '' && <div>
                              {"GSTIN: "}{storeDetails.storegstin}
                              <div>
                                <span className="">State : Kerala</span>
                                <span className="ms-2">Code : 32</span>
                              </div>
                          </div>
                          }
                        </td>
                        <td className="pb-0">
                          <address>
                            Billed To
                            <br />
                            <span className="ms-1"><strong>{customerDetails?.name}</strong></span><br/>
                            {customerDetails && customerDetails.address && customerDetails.address != '' ? <div className="ms-1">{customerDetails.address}</div>: ''}
                            {customerDetails && customerDetails.mobile && customerDetails.mobile != '' ? <div className="ms-1">{customerDetails.mobile}</div>: ''}
                            {customerDetails && customerDetails.phone && customerDetails.phone != '' ? <div className="ms-1">{customerDetails.phone}</div>: ''}
                            {customerDetails && customerDetails.email && customerDetails.email != '' ? <div className="ms-1">{customerDetails.email}</div>: ''}
                            {customerDetails && customerDetails.gstin && customerDetails.gstin != '' ? <div className="ms-1">{"GSTIN: "}{customerDetails.gstin}</div>: ''}
                            {customerDetails && customerDetails.statename && customerDetails.statename != '' ? <div className="ms-1">{"State: "}{customerDetails.statename}{", Code: "}{customerDetails.statecode}</div>: ''}
                          </address>
                        </td>
                        <td className="pb-0">
                          <div className="float-end">
                            {storeDetails && storeDetails.storelogo && storeDetails.storelogo != '' && 
                              <CardImg className="img-fluid logo-md" src={storeDetails.storelogo} alt="logo" />
                              
                            }
                            <div className="font-size-12 mt-2">
                              Inv No. : {salesDetails.invoiceno}
                            </div>
                            <div>
                              Date : {salesDetails.invoicedate && moment(new Date(salesDetails.invoicedate)).format("DD-MMM-YYYY, HH:mm ")}
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  {/*<div className="py-1 mt-0">
                    <h3 className="font-size-12 fw-bold mb-0">Summary</h3>
                  </div>*/}
                  <div className="table-responsive">
                    <Table className="table-nowrap border table-sm no-bottom-margin">
                      <thead className="table-light font-size-11">
                        <tr className="py-0">
                          <th style={{ width: "3%" }}>No.</th>
                          <th style={{ width: "52%" }}>Item</th>
                          <th style={{ width: "5%" }}>HSN</th>
                          <th style={{ width: "10%" }}>Rate & Qty </th>
                          <th style={{ width: "10%" }}>Price</th>
                          <th style={{ width: "5%" }}>GST</th>
                          <th style={{ width: "10%" }} className="text-end">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {map(
                          salesDetails.salesRows,
                          (item, key) => (
                            item.productid != '' && <tr key={key} className="py-1 font-size-11">
                              <td>{key+1}</td>
                              <td className="text-wrap">
                                {item.productname}
                              </td>
                              <td>{item.hsncode}</td>
                              <td>{Number(item.productrate).toLocaleString('en-IN',{minimumFractionDigits: 2})} × {item.productqty} <span className="text-muted font-size-10 ms-0">{item.selectedunitname}</span> </td>
                              <td>
                                {Number(item.productgrosswithouttax).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                {Number(item.productdisc) > 0 && <span className="font-size-9"><br/>-Disc {Number(item.productdisc).toLocaleString('en-IN',{minimumFractionDigits: 2})}</span>}
                              </td>
                              <td>{Number(item.productgst).toLocaleString('en-IN',{minimumFractionDigits: 2})}<span className="font-size-9">({item.gstpercentage}%)</span></td>
                              <td className="text-end">{Number(item.producttotal).toLocaleString('en-IN',{minimumFractionDigits: 2})}</td>
                            </tr>
                          )
                        )}
                          <tr className="py-1 fw-bold font-size-11">
                              <td></td>
                              <td className="text-wrap text-end">
                                Total
                              </td>
                              <td></td>
                              <td></td>
                              <td>
                                {Number(Number(salesDetails.totalgrosswithouttax)-Number(salesDetails.totaldisc)).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                              </td>
                              <td>{Number(salesDetails.totalgst).toLocaleString('en-IN',{minimumFractionDigits: 2})}</td>
                              <td className="text-end">{Number(salesDetails.totaltotal).toLocaleString('en-IN',{minimumFractionDigits: 2})}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <Table className="table-nowrap border table-sm no-bottom-margin">
                      <tbody>
                        <tr>
                          <td style={{ maxWidth: "30%" }}>
                            <Table className="table-nowrap border table-sm no-bottom-margin table-nopadd">
                              <tbody>
                                <tr>
                                  <td colSpan="3" className="text-center font-size-10 table-light">
                                    SGST Breakup
                                  </td>
                                </tr>
                                <tr>
                                  <td className="font-size-10">
                                    Rate
                                  </td>
                                  <td className="font-size-10">
                                    Taxable Amt
                                  </td>
                                  <td className="font-size-10">
                                    Tax
                                  </td>
                                </tr>
                              {map(
                                salesDetails.sgstArray,
                                (item, key) => (
                                  <tr key={key}>
                                    <td className="font-size-10">
                                    {item.tax}%
                                    </td>
                                    <td className="font-size-10">
                                    {Number(item.taxableamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                    </td>
                                    <td className="font-size-10">
                                    {Number(item.taxamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                    </td>
                                  </tr>
                                  )
                                )}
                              </tbody>
                            </Table>
                          </td>
                          <td style={{ maxWidth: "30%" }}>
                            <Table className="table-nowrap border table-sm no-bottom-margin table-nopadd">
                              <tbody>
                              <tr>
                                  <td colSpan="3" className="text-center font-size-10 table-light">
                                    CGST Breakup
                                  </td>
                                </tr>
                                <tr>
                                  <td className="font-size-10">
                                    Rate
                                  </td>
                                  <td className="font-size-10">
                                    Taxable Amt
                                  </td>
                                  <td className="font-size-10">
                                    Tax
                                  </td>
                                </tr>
                              {map(
                                salesDetails.cgstArray,
                                (item, key) => (
                                  <tr key={key}>
                                    <td className="font-size-10">
                                    {item.tax}%
                                    </td>
                                    <td className="font-size-10">
                                    {Number(item.taxableamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                    </td>
                                    <td className="font-size-10">
                                    {Number(item.taxamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                    </td>
                                  </tr>
                                  )
                                )}
                              </tbody>
                            </Table>
                          </td>
                          <td style={{ maxWidth: "30%" }}>
                            {size(salesDetails.igstArray) > 0 && 
                          <Table className="table-nowrap border table-sm no-bottom-margin table-nopadd">
                              <tbody>
                              <tr>
                                  <td colSpan="3" className="text-center font-size-10 table-light">
                                    IGST Breakup
                                  </td>
                                </tr>
                                <tr>
                                  <td className="font-size-10">
                                    Rate
                                  </td>
                                  <td className="font-size-10">
                                    Taxable Amt
                                  </td>
                                  <td className="font-size-10">
                                    Tax
                                  </td>
                                </tr>
                              {map(
                                salesDetails.igstArray,
                                (item, key) => (
                                  <tr key={key}>
                                    <td className="font-size-10">
                                    {item.tax}%
                                    </td>
                                    <td className="font-size-10">
                                    {Number(item.taxableamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                    </td>
                                    <td className="font-size-10">
                                    {Number(item.taxamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                    </td>
                                  </tr>
                                  )
                                )}
                              </tbody>
                            </Table>
                            }
                          </td>
                          <td style={{ maxWidth: "40%" }}>
                          <Table className="table-nowrap border table-sm no-bottom-margin font-size-11">
                            <tbody>
                              {isNonZeroNumber(salesDetails.loadingcharges) &&
                              <tr>
                                <td className="py-0" style={{ width: "5%" }}></td>
                                <td className="py-0" style={{ width: "35%" }}></td>
                                <td style={{ width: "30%" }} className="text-end py-0">
                                  Loading Charges
                                </td>
                                <td style={{ width: "30%" }} className="text-end py-0">
                                  {Number(salesDetails.loadingcharges).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                </td>
                              </tr>
                              }
                              {isNonZeroNumber(salesDetails.othercharges) &&
                              <tr>
                                <td className="py-0" style={{ width: "5%" }}></td>
                                <td className="py-0" style={{ width: "35%" }}></td>
                                <td style={{ width: "30%" }} className="text-end py-0">
                                  Other Charges
                                </td>
                                <td style={{ width: "30%" }} className="text-end py-0">
                                  {Number(salesDetails.othercharges).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                </td>
                              </tr>
                              }
                              {isNonZeroNumber(salesDetails.otherexpences) &&
                              <tr>
                                <td className="py-0" style={{ width: "5%" }}></td>
                                <td className="py-0" style={{ width: "35%" }}></td>
                                <td style={{ width: "30%" }} className="text-end py-0">
                                  Other Expenses
                                </td>
                                <td style={{ width: "30%" }} className="text-end py-0">
                                  {Number(salesDetails.otherexpences).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                </td>
                              </tr>
                              }
                              {isNonZeroNumber(salesDetails.discounts) &&
                              <tr>
                                <td className="py-0" style={{ width: "5%" }}></td>
                                <td className="py-0" style={{ width: "35%" }}></td>
                                <td style={{ width: "30%" }} className="text-end font-size-14 py-0">
                                <strong>Discounts</strong>
                                </td>
                                <td style={{ width: "30%" }} className="text-end font-size-14 py-0">
                                <strong>{Number(salesDetails.discounts).toLocaleString('en-IN',{minimumFractionDigits: 2})}</strong>
                                </td>
                              </tr>
                              }
                              {isNonZeroNumber(salesDetails.roundoff) &&
                              <tr>
                                <td className="py-0" style={{ width: "5%" }}></td>
                                <td className="py-0" style={{ width: "35%" }}></td>
                                <td style={{ width: "30%" }} className="text-end py-0">
                                  Round Off
                                </td>
                                <td style={{ width: "30%" }} className="text-end py-0">
                                  {Number(salesDetails.roundoff).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                                </td>
                              </tr>
                              }
                              <tr>
                                <td className="py-0" style={{ width: "5%" }}></td>
                                <td className="py-0" style={{ width: "35%" }}></td>
                                <td className="py-0" style={{ width: "30%" }} className="text-end font-size-12 py-0">
                                <strong>Grand Total (INR)</strong>
                                </td>
                                <td style={{ width: "30%" }} className="text-end font-size-13 py-0">
                                  <strong>{Number(salesDetails.grandtotal).toLocaleString('en-IN',{minimumFractionDigits: 2})}</strong>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                    <Table className="table-nowrap border table-sm font-size-11">
                      <tbody>
                        {isNonZeroNumber(salesDetails.cashreceived) &&
                        <tr>
                          <td className="py-0" style={{ width: "5%" }}></td>
                          <td className="text-wrap py-0">
                            Amount Received (INR)
                          </td>
                          <td className="text-wrap py-0" colSpan="2" >
                            {Number(salesDetails.cashreceived).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                            {" "}<span className=" ">({toWords.convert(salesDetails.cashreceived)})</span>
                          </td>
                        </tr>
                        }
                        {isNonZeroNumber(salesDetails.writeoff) &&
                        <tr>
                          <td className="py-0" style={{ width: "5%" }}></td>
                          <td className="text-wrap ">
                            Write Off(INR)
                          </td>
                          <td className="text-wrap py-0" colSpan="2" >
                            {Number(salesDetails.writeoff).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                            {" "}<span className=" ">({toWords.convert(salesDetails.writeoff)})</span>
                          </td>
                        </tr>
                        }
                        {isNonZeroNumber(salesDetails.balanceamount) &&
                        <tr>
                          <td className="py-0" style={{ width: "5%" }}></td>
                          <td className="text-wrap py-0">
                            Balance Amount (INR)
                          </td>
                          <td className="text-wrap py-0" colSpan="2" >
                            {Number(salesDetails.balanceamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}
                          </td>
                        </tr>
                        }
                        <tr>
                          <td className="py-0" style={{ width: "5%" }}></td>
                          <td className="py-0" style={{ width: "35%" }}></td>
                          <td colSpan="2" className="text-end py-0">
                            For <span className=""> {storeDetails.storename}  </span><br/>
                            <div className="pt-3">Authorised Signatory</div>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="2" className="text-wrap py-0">
                            E & O.E
                          </td>
                          <td colSpan="2" className="text-end py-0">
                            Thank you
                          </td>
                        </tr>
                        {defaultFootNote && defaultFootNote != '' && <tr className="">
                          <td colSpan="4" className="text-wrap text-center pb-2">
                            <small>{defaultFootNote}</small>
                          </td>
                        </tr>}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
        </Container>
      </div>
    </React.Fragment>
  )
});

export default InvoiceDetailV5
